import request from '@/utils/request'
import config from '@/config'

export default {
  // 查询测站雨量累计值
  getAccumulateRain (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetAccumulateRain', { params })
  },
  // 查询实时水情数据
  getLatestWaterLevel (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetLatestWaterLevel', { params })
  },
  // 查询实时水情中对应stid水库72小时数据
  getRainWaterMinutesTotal (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/GetRainWaterMinutesTotal', { params })
  },
  // 获得图层控制数据
  getLayerControlData (params) {
    return request.get(config.ApiYJ + '/warninfo/GetLayerControlData', { params })
  },
  // 预警信息-预警信息列表
  getEarlyWarningList (params) {
    return request.get(config.ApiYJ + '/WarnRecord/WarnRecordList', { params })
  },
  // 获取雨情/水位数据
  getYuRunData (params) {
    return request.get(config.ApiYSQ + '/HydrologyCenter/Get5MYuRunData', { params })
  },
  // 获取水利工程单个站点详情数据
  getItemData (params) {
    return request.get(config.ApiLAVideo + '/engineering/item', { params })
  },
  // 获取水系面信息
  getRiverGeomList (params) {
    return request.get(config.ApiYJ + '/SituationAnalyse/GetRiverGeomList', { params })
  },
  // 获取降雨等值面信息
  getRianGraph (params) {
    return request.get(config.ApiYJ + '/RainWater/GetRianGraph', { params })
  }
}
